import axiosInstance from "./service-instance";
import QueryString from "query-string";

export default {
    fetchPaymentProgramDetails: (ordering, page, page_size, filters) =>
        axiosInstance.get(`/workflow/payment-program/?${QueryString.stringify({...filters})}`, {
            params: {
                ordering,
                page,
                page_size,
            }
        }),
    fetchPaymentProgramActionDetails : (case_id , onboarding_id) => 
        axiosInstance.get(`/workflow/${onboarding_id}/extra-data/`),
    
    approveRejectDocument: (data,companyId, action) =>
        axiosInstance.put(`document/${companyId}/inactive-or-change-status/action-detail/document/`, 
            data, 
            {
                params: {
                    action
                }
            }),
    
    referBackProceedDocument: (taskId, action) =>
        axiosInstance.post(`workflow/task/${taskId}/action/`, {},
            {
                params: {
                    action
                }
            }),

    proceedPPCase : (taskId) => axiosInstance.post(`workflow/task/${taskId}/proceed/retail/`),
    rejectPPCase : (taskId) => axiosInstance.post(`workflow/task/${taskId}/action/?action=refer`),


    fetchPayProCaseNote: (actionDetailId) =>
        axiosInstance.get(`workflow/${actionDetailId}/note/list/`),

    updateUserDocumentSerivce : (company_id , associate) => 
        axiosInstance.post(`company/associate/${company_id}/create-update` , associate , {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateCaseChecklist : (caseId) => 
        axiosInstance.put(`/case/${caseId}/action-detail/update/case-checklist-json/`),
        
    validateDocument: (company_id, document_id, data) =>
        axiosInstance.put(`/company/${company_id}/document-master/${document_id}/detail/`, data),

    updateEntityDocuments: (company_id , action_detail_id , data) => 
        axiosInstance.post(`document/${company_id}/parse-entity/${action_detail_id}/` , data),
        
    bulkAssignCases: (action_task_ids , remarks , user) => 
        axiosInstance.post("workflow/action-task/bulk-assign/" , {
            action_task_ids: action_task_ids,
            action_remarks : remarks, 
            this_user : user
        }),
    paymentProgramService: (fieldsValue,id) => 
        axiosInstance.post("workflow/user/update/payment-program/" , {
            name:fieldsValue.username,
            email:fieldsValue.email,
            mobile_number:fieldsValue.contact_number,
            action_detail_id:id


            
        }),
    assignCaseSelf: (action_task_id, remarks, user) =>
        axiosInstance.put(`workflow/action-task/assign/${action_task_id}/`,
            {
                action_remarks: remarks,
                this_user: user

            }
        ),
    getPPKycCount : () => 
        axiosInstance.get("workflow/action-task/payment-count/" , {
            params :{
                application_name : "hero-my-funds-onboarding"
            }
        }),
    uploadDocumentPP : (file , company_id , document_option , document_id , associate_id ,associate_key , action_detail_id) => {
        let formData = new FormData();
        formData.append("file" , file);
        formData.append("file_name" , "file_name");
        formData.append("associate_key" , associate_key);
        formData.append("document" , document_id);

        return axiosInstance.post(`document/${company_id}/upload/?action_detail_id=${action_detail_id}&associate_id=${associate_id}&document_option=${document_option}&source=${"SOUL"}` , formData,{
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    deleteDocumentPP : (companyId, data) => {
        return axiosInstance.put(`/document/${companyId}/inactive-or-change-status/action-detail/document/?action=Inactive&source=${"SOUL"}`, { ...data });
    }

};